import { render, staticRenderFns } from "./ReportsInfoHeader.vue?vue&type=template&id=38b5ff58&"
import script from "./ReportsInfoHeader.vue?vue&type=script&lang=js&"
export * from "./ReportsInfoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports